import hasAccessGuard from "@/guards/hasTokenGuard";
import verifyTokenRecoverPassword from "@/guards/verifyTokenRecoverPassword";

export default {
    name: 'auth',
    component: () => import(/* webpackChunkName: "auth-layout" */ '@/modules/auth/layouts/AuthLayout.vue'),
    children: [
        {
            path: '',
            name: 'auth-login',
            beforeEnter: [hasAccessGuard],
            component: () => import(/* webpackChunkName: "auth-login" */ '@/modules/auth/views/Login.vue'),
        },
        {
            path: '/sso/:response',
            name: 'response-sso',
            component: () => import(/* webpackChunkName: "auth-login" */ '@/modules/auth/views/Login.vue'),
        },
        {
            path: '/password-recovery',
            name: 'auth-password-recovery',
            beforeEnter: [hasAccessGuard],
            component: () => import(/* webpackChunkName: "auth-login" */ '@/modules/auth/views/PasswordRecovery.vue'),
        },
        {
            path: '/questions',
            name: 'auth-questions',
            beforeEnter: [hasAccessGuard],
            component: () => import(/* webpackChunkName: "auth-login" */ '@/modules/auth/views/Questions.vue'),
        },
        {
            path: '/password-confirmation',
            name: 'auth-password-confirmation',
            beforeEnter: [hasAccessGuard],
            component: () => import(/* webpackChunkName: "auth-login" */ '@/modules/auth/views/PasswordConfirmation.vue'),
        },
        // ── Rutas 2FA ────────────────────────────────────────────────────────
        {
            path: '/login/2fa/canal',
            name: 'auth-2fa-channel',
            component: () => import(/* webpackChunkName: "auth-2fa" */ '@/modules/auth/views/TwoFactorChannelView.vue'),
        },
        {
            path: '/login/2fa/codigo',
            name: 'auth-2fa-code',
            component: () => import(/* webpackChunkName: "auth-2fa" */ '@/modules/auth/views/TwoFactorCodeView.vue'),
        },
        // ─────────────────────────────────────────────────────────────────────
        {
            path: '/invitation/:token',
            name: 'auth-invitation-accept',
            component: () => import(/* webpackChunkName: "auth-invitation" */ '@/modules/auth/views/InvitationAccept.vue'),
        },
    ]
}
